import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { Icons } from '@/shared/ui';

import styles from './HomeDashboard.module.css';

/**
 * The header every resource section of Home shares: title, a quiet count and, at the right edge,
 * the link to that resource's complete catalog (plus optional extra icon links).
 */
export function SectionHead({
  id,
  title,
  count,
  to,
  linkLabel,
  linkTestId,
  extra,
}: {
  id: string;
  title: string;
  /** `null` while unknown (loading): nothing is shown rather than a wrong number. */
  count: number | null;
  to: string;
  linkLabel: string;
  linkTestId?: string;
  extra?: ReactNode;
}) {
  return (
    <header className={styles.sectionHead}>
      <h2 id={id} className={styles.sectionTitle}>
        {title}
        {count !== null && <span className={styles.sectionCount}> ({count})</span>}
      </h2>
      <div className={styles.sectionLinks}>
        {extra}
        <Link to={to} className={styles.viewAll} {...(linkTestId && { 'data-testid': linkTestId })}>
          {linkLabel}
          <Icons.arrowRight />
        </Link>
      </div>
    </header>
  );
}
